<script>
export default {
  inheritAttrs: false,
  props: {
    time: {
      type: Number,
      default: 0
    },
    notify: {
      type: Boolean,
      default: true
    },
    reserveFlg: Boolean
  },
  methods: {
    renderBlock(data) {
      let str = new String(data);
      str.length === 1 && (str = `0${str}`);
      return [<div class="block">{str[0]}</div>, <div class="block">{str[1]}</div>];
    },
    reserve() {
      this.$emit('reserve');
    }
  },
  render() {
    const props = {
      props: {
        ...this.$attrs,
        time: this.time
      },
      style: { width: '100%' },
      scopedSlots: {
        default: (props) => {
          return (
            <div class="slot-wrap">
              <div class="time-wrap">
                <div class="block-wrap">
                  {this.renderBlock(props.days)}
                  <div class="colon">天</div>
                </div>
                <div class="block-wrap">
                  {this.renderBlock(props.hours)}
                  <div class="colon">时</div>
                </div>
                <div class="block-wrap">
                  {this.renderBlock(props.minutes)}
                  <div class="colon">分</div>
                </div>
                <div class="block-wrap">
                  {this.renderBlock(props.seconds)}
                  <div class="colon">秒</div>
                </div>
              </div>
              {this.notify ? (
                <div class={{ reserved: this.reserveFlg, action: true }} onclick={this.reserve}>
                  {this.reserveFlg ? '已预约' : '直播预约'}
                </div>
              ) : null}
            </div>
          );
        }
      },
      on: {
        ...this.$listeners
      }
    };
    return this.time ? (
      <div class="count-down-small-wrap">
        <van-count-down {...props}></van-count-down>
      </div>
    ) : null;
  }
};
</script>
